import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormButtonsConfig } from "@mipro/components";
import { NamingConventionService } from "@mipro/services/naming-convention.service";

@Component({
    selector: "formio-select-patient-dialog",
    templateUrl: "./formio-select-patient-dialog.component.html"
})

export class FormIOPatientSelectDialogComponent {
    @Output() readonly onOk = new EventEmitter<string>();
    @Output() readonly onCancel = new EventEmitter();

    patientId: string = null;

    buttonsConfig = <FormButtonsConfig>{
        saveLabel: "OK",
        saveFunc: () => {
            this.onOk.emit(this.patientId);
        },
        cancelFunc: () => {
            this.onCancel.emit();
        }
    };

 
    constructor(
        public namingConvService: NamingConventionService) {
    }

 }
